<template>
  <div class="s-toggle-comp" @click="toggle">
    <i class="s-toggle-default" :class="{'s-toggle-active' : modelValue }"></i>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Boolean
  },
  emits: ['update:modelValue'],
  data() {
    return {
    };
  },
  methods: {
    toggle() {
      this.$emit('update:modelValue',!this.modelValue);
    }
  }
};
</script>

